import {
  CurrencyIso,
  CurrencyUnits,
  BaseCurrency,
  CurrencyType,
  CurrencyValue,
} from "./types";

/**
 * Convenience wrapper for currency
 * form based on https://github.com/wiredmax/world-currencies/tree/master/dist/json/countries
 */
export class CurrencyWrapper {
  name: string;
  iso: CurrencyIso;
  units: CurrencyUnits;
  bankNotes: BaseCurrency;
  coins: BaseCurrency;

  constructor(currency: CurrencyType) {
    this.name = currency.name;
    this.iso = currency.iso;
    this.units = currency.units;
    this.bankNotes = currency.banknotes;
    this.coins = currency.coins;
  }

  static formatCurrency(currencyValue: CurrencyValue, units: CurrencyUnits) {
    if (currencyValue.unitType === "minor") {
      return `${currencyValue.value}${units.minor.symbol}`;
    } else {
      const isWholeNumber =
        currencyValue.value - Math.floor(currencyValue.value) === 0;
      const formattedValue = isWholeNumber
        ? currencyValue.value
        : currencyValue.value.toFixed(2);
      return `${units.major.symbol}${formattedValue}`;
    }
  }

  static getMajorValue(currencyValue: CurrencyValue, units: CurrencyUnits) {
    if (currencyValue.unitType === "major") {
      return currencyValue.value;
    } else {
      return currencyValue.value * units.minor.majorValue;
    }
  }

  getAllCurrencies() {
    const allCurrencies = [
      ...this.bankNotes.frequent,
      ...this.bankNotes.rare,
      ...this.coins.frequent,
      ...this.coins.rare,
    ].flat();

    return allCurrencies;
  }
}

export const currencies: { [key: string]: CurrencyType } = {
  AUD: {
    name: "Australian Dollar",
    iso: {
      code: "AUD",
      number: "036",
    },
    units: {
      major: {
        name: "dollar",
        symbol: "$",
      },
      minor: {
        name: "cent",
        symbol: "c",
        majorValue: 0.01,
      },
    },
    banknotes: {
      frequent: [
        { value: 5, unitType: "major" },
        { value: 10, unitType: "major" },
        { value: 20, unitType: "major" },
        { value: 50, unitType: "major" },
        { value: 100, unitType: "major" },
      ],
      rare: [],
    },
    coins: {
      frequent: [
        { value: 1, unitType: "major" },
        { value: 2, unitType: "major" },
        { value: 5, unitType: "minor" },
        { value: 10, unitType: "minor" },
        { value: 20, unitType: "minor" },
        { value: 50, unitType: "minor" },
      ],
      rare: [],
    },
  },
};
